<template>
    <div class="shadow-md p-3 font-primary">
      <b>Pedido creado correctamente!</b> <br>
      <p v-if="numped">Numero de pedido: {{ numped }}</p><br>
      Por cualquier duda o inquietud, contacte a nuestro equipo de ventas. <br>
      <RouterLink to="/catalogo" class="btn btn-danger btn-sm mt-5">Volver a inicio</RouterLink>
    </div>
  </template>
  
  <script>
  import configService from '@/services/config.service';
  export default {
    data() {
      return {
        numped: ''
      };
    },
    mounted() {
        this.getNumpedCli()
    },
    methods: {
        getNumpedCli() {
            // aca deberia ser getNumpedCli
            configService.getNumpedCli()
                .then((res) => {
                    this.numped = Number(res.data)
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    },
    computed: {
    },
  };
  </script>

